import React, { ReactNode } from "react";
import { makeStyles, Box, Grid, colors } from "@material-ui/core";

import { ICIPAdminScreenProps } from "../ICIPAdminScreen";

interface ListTileProps extends ICIPAdminScreenProps {
  children?: ReactNode;
  title?: ReactNode;

  main?: boolean;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: "100%",
    },

    content: {
      margin: 0,

      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: "32px",
      paddingRight: "32px",

      "& .title": {
        fontSize: 14,
        color: (props: ListTileProps) =>
          !props.main ? colors.grey[600] : theme.palette.text.primary,
        fontWeight: (props: ListTileProps) =>
          !props.main
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,

        "& .titleBox": {
          marginTop: "2px",
        },
      },

      "& .subTitle": {
        fontSize: 16,
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  }),
  { name: "list-tile-styles" }
);

export default function ListTile(props: ListTileProps) {
  const classes = useStyles(props);
  // Props
  const { title, children } = props;

  return (
    <Box className={classes.root}>
      <Grid className={classes.content} container>
        <Grid className="title" item xs={12} sm={3}>
          <Box className="titleBox">{title}</Box>
        </Grid>
        <Grid className="subTitle" item xs={12} sm={9}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
}

ListTile.defaultProps = {
  ListTile: false,
};
